var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outermostLayer",staticStyle:{"margin":"0px 0 20px"}},[_vm._v("123\n")])}
var staticRenderFns = []

export { render, staticRenderFns }